var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6109 7.55114L16.7805 6.38081C17.0243 6.13698 17.355 6 17.6998 6C18.0447 6 18.3754 6.13698 18.6192 6.38081C18.863 6.62463 19 6.95533 19 7.30015C19 7.64498 18.863 7.97568 18.6192 8.2195L11.2568 15.5819C10.8902 15.9482 10.4382 16.2175 9.94155 16.3654L8.07997 16.92L8.63463 15.0585C8.7825 14.5618 9.05176 14.1098 9.41809 13.7432L15.6109 7.55114ZM15.6109 7.55114L17.4398 9.38013M16.3999 14.1467V17.44C16.3999 17.8538 16.2355 18.2505 15.943 18.5431C15.6504 18.8356 15.2536 19 14.8399 19H7.55998C7.14625 19 6.74946 18.8356 6.45691 18.5431C6.16435 18.2505 6 17.8538 6 17.44V10.1601C6 9.74638 6.16435 9.3496 6.45691 9.05704C6.74946 8.76449 7.14625 8.60014 7.55998 8.60014H10.8533",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEditIcon);
export default __webpack_public_path__ + "static/media/imgEditIcon.f0d574d784a9e9fc04957c694594ddea.svg";
export { ForwardRef as ReactComponent };